import genericTabConst from '@/consts/genericTab.const';

export default {
  isLeaseTab(tabId) {
    return tabId === genericTabConst.LEASE_RESEARCH || tabId === genericTabConst.LEASE_COMPS;
  },

  isRentSurveyTab(tabId) {
    return tabId === genericTabConst.RENT_SURVEY_COMPS;
  },

  isSalesTab(tabId) {
    return tabId === genericTabConst.SALES_RESEARCH || tabId === genericTabConst.SALES_COMPS;
  },

  isLandTab(tabId) {
    return tabId === genericTabConst.LAND_RESEARCH || tabId === genericTabConst.LAND_COMPS;
  },

  isIETab(tabId) {
    return tabId === genericTabConst.IE_COMPS;
  },
};
